import { render, staticRenderFns } from "./importTeachers.vue?vue&type=template&id=27b12b32&scoped=true"
import script from "./importTeachers.vue?vue&type=script&lang=js"
export * from "./importTeachers.vue?vue&type=script&lang=js"
import style0 from "./importTeachers.vue?vue&type=style&index=0&id=27b12b32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b12b32",
  null
  
)

export default component.exports